// Funciones para integrar datos del formulario de facturación con el checkout de Shopify

// Función para formatear URLs con parámetros
function urlFormatter(url, parameters) {
  let parts = url.split('?');
  url = parts[0];
  let newParameters = [];
  let map = [];
  
  if (parts[1] != null) {
    let oldParameters = parts[1].split('&');
    for (let i in oldParameters) {
      let keyValue = oldParameters[i].split('=');
      map[keyValue[0]] = keyValue[1];
    }
  }
  
  for (let i in parameters) {
    let parameter = parameters[i];
    map[parameter.name] = parameter.value;
  }
  
  for (let i in map) {
    let value = map[i];
    newParameters.push(i + '=' + value);
  }
  
  return url + '?' + newParameters.join('&');
}

// Función para actualizar atributos del carrito y redirigir al checkout
function updateAdditionalAttributes(attributes, parameters) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      attributes: attributes,
    }),
  })
  .then((response) => {
    console.log('Attributes updated');
    let url = urlFormatter('/checkout', parameters);
    window.location.href = url;
  })
  .catch((error) => {
    console.error('Error updating cart attributes:', error);
    // Fallback: redirigir al checkout sin parámetros
    window.location.href = '/checkout';
  });
}

// Función específica para el formulario de facturación electrónica
function transferBillingDataToCheckout() {
  // Recopilar datos del formulario
  const documentType = document.getElementById("document_type").value;
  const documentNumber = document.getElementById("document_number").value;
  const firstName = document.getElementById("first_name").value;
  const lastName = document.getElementById("last_name").value;
  const companyName = document.getElementById("company_name").value;
  const departamento = document.getElementById("custom_provinces_ship").value;
  const ciudad = document.getElementById("custom_cities_ship").value;
  const ciudadText = document.getElementById("custom_cities_ship").selectedOptions[0]?.textContent || '';
  
  // Variable de dirección (puede ser personalizada según tus necesidades)
  let addr = ''; // Esta variable se puede definir según tus necesidades específicas
  
  // Crear objeto de atributos para cart.attributes (solo datos relevantes)
  let attributes = {
    'departamento': document.getElementById("custom_provinces_ship").value,
    'ciudad': document.getElementById("custom_cities_ship").value,
    'tipodoc': document.getElementById("document_type").value,
    'documento': document.getElementById("document_number").value,
    'direccion': addr
  };
  
  // Agregar datos específicos según el tipo de documento
  if (documentType === "nit") {
    attributes['company_name'] = companyName;
  } else if (documentType === "cc") {
    attributes['first_name'] = firstName;
    attributes['last_name'] = lastName;
  }
  
  // Crear parámetros para el checkout basados en el tipo de documento
  let parameters = [
    {
      name: "checkout[shipping_address][country]",
      value: 'CO'
    },
    {
      name: "checkout[shipping_address][province]",
      value: document.getElementById("custom_provinces_ship").selectedOptions[0]?.getAttribute("data-sh-code") || document.getElementById("custom_provinces_ship").value
    },
    {
      name: "checkout[shipping_address][city]",
      value: document.getElementById("custom_cities_ship").selectedOptions[0]?.textContent || ''
    },
    {
      name: "checkout[shipping_address][address1]",
      value: addr
    }
  ];
  
  // Agregar campos específicos según el tipo de documento
  if (documentType === "nit") {
    // Para NIT: usar número de documento como company (estándar colombiano)
    parameters.push({
      name: "checkout[shipping_address][company]",
      value: documentNumber
    });
    // Usar razón social como nombre (first_name)
    if (companyName) {
      parameters.push({
        name: "checkout[shipping_address][first_name]",
        value: companyName
      });
    }
    // También agregar razón social en address2 como información adicional
    if (companyName) {
      parameters.push({
        name: "checkout[shipping_address][address2]",
        value: companyName
      });
    }
  } else if (documentType === "cc") {
    // Para CC: usar número de documento como company (estándar colombiano)
    parameters.push({
      name: "checkout[shipping_address][company]",
      value: documentNumber
    });
    // Agregar nombre y apellido
    if (firstName) {
      parameters.push({
        name: "checkout[shipping_address][first_name]",
        value: firstName
      });
    }
    if (lastName) {
      parameters.push({
        name: "checkout[shipping_address][last_name]",
        value: lastName
      });
    }
  }
  
  // Actualizar atributos y redirigir
  updateAdditionalAttributes(attributes, parameters);
}

// Función para interceptar el envío del formulario
function setupCheckoutIntegration() {
  console.log('Setting up checkout integration...');
  
  // Interceptar botones de checkout específicos
  const checkoutButtons = document.querySelectorAll('button[name="checkout"], button[name="add"], input[name="add"], .btn-checkout, [href*="/checkout"], .cart__checkout, .cart__submit, .hdt-main-cart__button-checkout');
  
  console.log('Found checkout buttons:', checkoutButtons.length);
  
  checkoutButtons.forEach(button => {
    console.log('Adding listener to button:', button);
    
    button.addEventListener('click', function(e) {
      console.log('Checkout button clicked!');
      
      // Verificar que el formulario esté completo
      const documentType = document.getElementById("document_type");
      const documentNumber = document.getElementById("document_number");
      const name = document.getElementById("first_name");
      const lastName = document.getElementById("last_name");
      const companyNameEl = document.getElementById("company_name");
      const departamento = document.getElementById("custom_provinces_ship");
      const ciudad = document.getElementById("custom_cities_ship");
      
      if (!documentType || !documentNumber || !departamento || !ciudad) {
        console.log('Form elements not found');
        return;
      }
      
      const docTypeValue = documentType.value;
      const docNumberValue = documentNumber.value;
      const deptValue = departamento.value;
      const cityValue = ciudad.value;
      
      // Obtener valores de los campos según el tipo de documento
      let nameValue = "";
      let lastnameValue = "";
      let companyValue = "";

      // Validación condicional según el tipo de documento
      if (docTypeValue === "cc") {
        nameValue = name?.value || "";
        lastnameValue = lastName?.value || "";
        if (!docNumberValue || !nameValue || !lastnameValue || !deptValue || !cityValue) {
          alert("Por favor complete todos los campos obligatorios del formulario de facturación (Cédula).");
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      } else if (docTypeValue === "nit") {
        companyValue = companyNameEl?.value || "";
        if (!docNumberValue || !companyValue || !deptValue || !cityValue) {
          alert("Por favor complete todos los campos obligatorios del formulario de facturación (NIT).");
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      } else {
        alert("Por favor seleccione un tipo de documento.");
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      
      console.log('Form values:', { docTypeValue, docNumberValue, nameValue, lastnameValue, companyValue, deptValue, cityValue });
      
      e.preventDefault();
      e.stopPropagation();
      
      console.log('Transferring data to checkout...');
      // Transferir datos al checkout
      transferBillingDataToCheckout();
    });
  });
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function() {
  setupCheckoutIntegration();
});

// También ejecutar en diferentes eventos de carga
window.addEventListener('load', setupCheckoutIntegration);

console.log('Checkout integration loaded');